module.exports = __webpack_public_path__ + "static/media/JiaoYu4.49ee75a9.png";